export const FeatureFlags = {
  showAiProtocolFeedback: "showAiProtocolFeedback",
  aiProtocolHideSummary: "aiProtocolHideSummary",
  caseRequiresPtNameAndDOB: "caseRequiresPtNameAndDOB",
} as const;
